var _path, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcons8Git(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0,0,256,256",
    width: "48px",
    height: "48px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    fill: "#f1edd5",
    fillRule: "nonzero",
    stroke: "none",
    strokeWidth: 1,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    strokeMiterlimit: 10,
    strokeDasharray: "",
    strokeDashoffset: 0,
    fontFamily: "none",
    fontWeight: "none",
    fontSize: "none",
    textAnchor: "none",
    style: {
      mixBlendMode: "normal"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0,256v-256h256v256z",
    id: "bgRectangle"
  }))), /*#__PURE__*/React.createElement("g", {
    fill: "#f4511e",
    fillRule: "nonzero",
    stroke: "none",
    strokeWidth: 1,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    strokeMiterlimit: 10,
    strokeDasharray: "",
    strokeDashoffset: 0,
    fontFamily: "none",
    fontWeight: "none",
    fontSize: "none",
    textAnchor: "none",
    style: {
      mixBlendMode: "normal"
    }
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "scale(5.33333,5.33333)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M42.2,22.1l-16.3,-16.3c-0.5,-0.5 -1.2,-0.8 -1.9,-0.8v0c-0.7,0 -1.4,0.3 -1.9,0.8l-3.5,3.5l4.1,4.1c0.4,-0.2 0.8,-0.3 1.3,-0.3c1.7,0 3,1.3 3,3c0,0.5 -0.1,0.9 -0.3,1.3l4,4c0.4,-0.2 0.8,-0.3 1.3,-0.3c1.7,0 3,1.3 3,3c0,1.7 -1.3,3 -3,3c-1.7,0 -3,-1.3 -3,-3c0,-0.5 0.1,-0.9 0.3,-1.3l-4,-4c-0.1,0 -0.2,0.1 -0.3,0.1v10.4c1.2,0.4 2,1.5 2,2.8c0,1.7 -1.3,3 -3,3c-1.7,0 -3,-1.3 -3,-3c0,-1.3 0.8,-2.4 2,-2.8v-10.5c-1.2,-0.4 -2,-1.5 -2,-2.8c0,-0.5 0.1,-0.9 0.3,-1.3l-4.1,-4.1l-11.4,11.5c-0.5,0.5 -0.8,1.2 -0.8,1.9c0,0.7 0.3,1.4 0.8,1.9l16.3,16.3v0c0.5,0.5 1.2,0.8 1.9,0.8c0.7,0 1.4,-0.3 1.9,-0.8l16.3,-16.3c0.5,-0.5 0.8,-1.2 0.8,-1.9c0,-0.7 -0.3,-1.4 -0.8,-1.9z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcons8Git);
export default __webpack_public_path__ + "static/media/icons8-git.f9cb9db8da5aa2300241486304b98081.svg";
export { ForwardRef as ReactComponent };